import React from 'react';

const IconInfoMenu = props => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="8"
      fill="none"
      viewBox="0 0 10 8"
    >
      <path
        stroke="#19191A"
        strokeLinecap="round"
        d="M3.5 1h6M.5 4h9M5.5 7h4"
      ></path>
    </svg>
  );
};

export default IconInfoMenu;
